export default "__VITE_ASSET__CQ00n1Bb__"